const CDN_PROXY_BASE = "https://phpropertyfinders.com/cdn"

export function toProxiedUrl(cloudinaryUrl: string): string {
  if (!cloudinaryUrl || !cloudinaryUrl.includes("res.cloudinary.com")) {
    return cloudinaryUrl
  }
  const match = cloudinaryUrl.match(/res\.cloudinary\.com\/[^/]+\/(.+)/)
  return match ? `${CDN_PROXY_BASE}/${match[1]}` : cloudinaryUrl
}
